import { OrderType } from "../models/order";

export function getOrderTypeColor(ordertypeName?: OrderType): {
  liteBg?: string;
  border: string;
  text: string;
  ring: string;
  fill: string;
  bg: string;
} {
  switch (ordertypeName) {
    case "Back order":
      return {
        liteBg: "bg-amber-50",
        border: "border-amber-500",
        text: "text-amber-900",
        ring: "ring-amber-800",
        fill: "fill-amber-600",
        bg: "bg-amber-200",
      };
    case "Original":
      return {
        liteBg: "bg-emerald-100",
        border: "border-emerald-500",
        text: "text-emerald-900",
        ring: "ring-emerald-500",
        fill: "fill-emerald-500",
        bg: "bg-emerald-200",
      };
    case "Relocation":
      return {
        liteBg: "bg-pink-100",
        border: "border-pink-500",
        text: "text-pink-900",
        ring: "ring-pink-500",
        fill: "fill-pink-500",
        bg: "bg-pink-200",
      };
    case "Opening":
      return {
        liteBg: "bg-sky-100",
        border: "border-sky-500",
        text: "text-sky-900",
        ring: "ring-sky-500",
        fill: "fill-sky-500",
        bg: "bg-sky-200",
      };
    /// More here if needed
    default:
      return {
        liteBg: "bg-gray-50",
        border: "border-gray-500",
        text: "text-gray-900",
        ring: "ring-gray-500",
        fill: "fill-gray-500",
        bg: "bg-gray-200",
      };
  }
}
